import { Component } from '@angular/core';
import {BaseState} from "@base/entities/BaseEntities";
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";

class State extends BaseState {
    Value: number = 0;
}

@Component({
    selector: 'app-demo-buttons',
    templateUrl: './demo-buttons.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoButtonsComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService) {
        super(A, 'DemoButtonsComponent', State);
    }

    public OnButtonClicked() {
        this.State.Value++;
    }
}
